export interface SingleResponse<T> {
  data: T;
}

export interface PaginatedResponse<T> {
  data: T[];
  meta: PaginationMetaData;
}

export interface PaginationMetaData {
  current_page: number;
  from: number;
  last_page: number;
  path: string;
  per_page: number;
  to: number;
  total: number;
}
export enum PERMISSION {
  ADMINISTRATION_AUTHOR_CREATE_ALL = "administration_author.create.*",
  ADMINISTRATION_AUTHOR_DELETE_ALL = "administration_author.delete.*",
  ADMINISTRATION_AUTHOR_READ_ALL = "administration_author.read.*",
  ADMINISTRATION_AUTHOR_UPDATE_ALL = "administration_author.update.*",
  ADMINISTRATION_DIAGNOSIS_CREATE_ALL = "administration_diagnosis.create.*",
  ADMINISTRATION_DIAGNOSIS_DELETE_ALL = "administration_diagnosis.delete.*",
  ADMINISTRATION_DIAGNOSIS_READ_ALL = "administration_diagnosis.read.*",
  ADMINISTRATION_DIAGNOSIS_UPDATE_ALL = "administration_diagnosis.update.*",
  ADMINISTRATION_EMAIL_CREATE_ALL = "administration_email.create.*",
  ADMINISTRATION_EMAIL_DELETE_ALL = "administration_email.delete.*",
  ADMINISTRATION_EMAIL_READ_ALL = "administration_email.read.*",
  ADMINISTRATION_EMAIL_UPDATE_ALL = "administration_email.update.*",
  ADMINISTRATION_PUBLICATION_CREATE_ALL = "administration_publication.create.*",
  ADMINISTRATION_PUBLICATION_DELETE_ALL = "administration_publication.delete.*",
  ADMINISTRATION_PUBLICATION_READ_ALL = "administration_publication.read.*",
  ADMINISTRATION_PUBLICATION_UPDATE_ALL = "administration_publication.update.*",
  ADMINISTRATION_TEAMMEMBER_CREATE_ALL = "administration_teammember.create.*",
  ADMINISTRATION_TEAMMEMBER_DELETE_ALL = "administration_teammember.delete.*",
  ADMINISTRATION_TEAMMEMBER_READ_ALL = "administration_teammember.read.*",
  ADMINISTRATION_TEAMMEMBER_UPDATE_ALL = "administration_teammember.update.*",
  DEVELOPMENT_CREATE_ALL = "development.create.*",
  DEVELOPMENT_DELETE_ALL = "development.delete.*",
  DEVELOPMENT_READ_ALL = "development.read.*",
  DEVELOPMENT_UPDATE_ALL = "development.update.*",
  INQUIRY_INQUIRY_CREATE_ALL = "inquiry_inquiry.create.*",
  INQUIRY_INQUIRY_DELETE_ALL = "inquiry_inquiry.delete.*",
  INQUIRY_INQUIRY_READ_ALL = "inquiry_inquiry.read.*",
  INQUIRY_INQUIRY_UPDATE_ALL = "inquiry_inquiry.update.*",
  PATIENT_CREATE_ALL = "patient.create.*",
  PATIENT_DELETE_ALL = "patient.delete.*",
  PATIENT_READ_ALL = "patient.read.*",
  PATIENT_UPDATE_ALL = "patient.update.*",
  PATIENTAUTHENTICATIONAUDIT_CREATE_ALL = "patientauthenticationaudit.create.*",
  PATIENTAUTHENTICATIONAUDIT_DELETE_ALL = "patientauthenticationaudit.delete.*",
  PATIENTAUTHENTICATIONAUDIT_READ_ALL = "patientauthenticationaudit.read.*",
  PATIENTAUTHENTICATIONAUDIT_UPDATE_ALL = "patientauthenticationaudit.update.*",
  PATIENTEVENT_CREATE_ALL = "patientevent.create.*",
  PATIENTEVENT_DELETE_ALL = "patientevent.delete.*",
  PATIENTEVENT_READ_ALL = "patientevent.read.*",
  PATIENTEVENT_UPDATE_ALL = "patientevent.update.*",
  PATIENTUSER_CREATE_ALL = "patientuser.create.*",
  PATIENTUSER_DELETE_ALL = "patientuser.delete.*",
  PATIENTUSER_READ_ALL = "patientuser.read.*",
  PATIENTUSER_UPDATE_ALL = "patientuser.update.*",
  PRIVATEATTACHMENT_CREATE_ALL = "privateattachment.create.*",
  PRIVATEATTACHMENT_DELETE_ALL = "privateattachment.delete.*",
  PRIVATEATTACHMENT_READ_ALL = "privateattachment.read.*",
  PRIVATEATTACHMENT_UPDATE_ALL = "privateattachment.update.*",
  QUALITYMANAGEMENT_PROCESS_CREATE_ALL = "qualitymanagement_process.create.*",
  QUALITYMANAGEMENT_PROCESS_DELETE_ALL = "qualitymanagement_process.delete.*",
  QUALITYMANAGEMENT_PROCESS_READ_ALL = "qualitymanagement_process.read.*",
  QUALITYMANAGEMENT_PROCESS_UPDATE_ALL = "qualitymanagement_process.update.*",
  QUALITYMANAGEMENT_PROCESSVERSION_CREATE_ALL = "qualitymanagement_processversion.create.*",
  QUALITYMANAGEMENT_PROCESSVERSION_DELETE_ALL = "qualitymanagement_processversion.delete.*",
  QUALITYMANAGEMENT_PROCESSVERSION_READ_ALL = "qualitymanagement_processversion.read.*",
  QUALITYMANAGEMENT_PROCESSVERSION_UPDATE_ALL = "qualitymanagement_processversion.update.*",
  QUALITYMANAGEMENT_SUBPROCESSPIVOT_CREATE_ALL = "qualitymanagement_subprocesspivot.create.*",
  QUALITYMANAGEMENT_SUBPROCESSPIVOT_DELETE_ALL = "qualitymanagement_subprocesspivot.delete.*",
  QUALITYMANAGEMENT_SUBPROCESSPIVOT_READ_ALL = "qualitymanagement_subprocesspivot.read.*",
  QUALITYMANAGEMENT_SUBPROCESSPIVOT_UPDATE_ALL = "qualitymanagement_subprocesspivot.update.*",
  QUALITYMANAGEMENT_SUBPROCESSPIVOTVERSION_CREATE_ALL = "qualitymanagement_subprocesspivotversion.create.*",
  QUALITYMANAGEMENT_SUBPROCESSPIVOTVERSION_DELETE_ALL = "qualitymanagement_subprocesspivotversion.delete.*",
  QUALITYMANAGEMENT_SUBPROCESSPIVOTVERSION_READ_ALL = "qualitymanagement_subprocesspivotversion.read.*",
  QUALITYMANAGEMENT_SUBPROCESSPIVOTVERSION_UPDATE_ALL = "qualitymanagement_subprocesspivotversion.update.*",
  SENTEMAIL_CREATE_ALL = "sentemail.create.*",
  SENTEMAIL_DELETE_ALL = "sentemail.delete.*",
  SENTEMAIL_READ_ALL = "sentemail.read.*",
  SENTEMAIL_UPDATE_ALL = "sentemail.update.*",
  SETTINGS_TABLEFILTERFAVORITE_CREATE_ALL = "settings_tablefilterfavorite.create.*",
  SETTINGS_TABLEFILTERFAVORITE_DELETE_ALL = "settings_tablefilterfavorite.delete.*",
  SETTINGS_TABLEFILTERFAVORITE_READ_ALL = "settings_tablefilterfavorite.read.*",
  SETTINGS_TABLEFILTERFAVORITE_UPDATE_ALL = "settings_tablefilterfavorite.update.*",
  TIMETRACKING_PUBLICHOLIDAY_CREATE_ALL = "timetracking_publicholiday.create.*",
  TIMETRACKING_PUBLICHOLIDAY_DELETE_ALL = "timetracking_publicholiday.delete.*",
  TIMETRACKING_PUBLICHOLIDAY_READ_ALL = "timetracking_publicholiday.read.*",
  TIMETRACKING_PUBLICHOLIDAY_UPDATE_ALL = "timetracking_publicholiday.update.*",
  TIMETRACKING_TIMETRACKINGABSENCEREQUEST_CREATE_ALL = "timetracking_timetrackingabsencerequest.create.*",
  TIMETRACKING_TIMETRACKINGABSENCEREQUEST_DELETE_ALL = "timetracking_timetrackingabsencerequest.delete.*",
  TIMETRACKING_TIMETRACKINGABSENCEREQUEST_READ_ALL = "timetracking_timetrackingabsencerequest.read.*",
  TIMETRACKING_TIMETRACKINGABSENCEREQUEST_UPDATE_ALL = "timetracking_timetrackingabsencerequest.update.*",
  TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEE_CREATE_ALL = "timetracking_timetrackingemployee_timetrackingemployee.create.*",
  TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEE_DELETE_ALL = "timetracking_timetrackingemployee_timetrackingemployee.delete.*",
  TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEE_READ_ALL = "timetracking_timetrackingemployee_timetrackingemployee.read.*",
  TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEE_UPDATE_ALL = "timetracking_timetrackingemployee_timetrackingemployee.update.*",
  TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEEWEEKLYWORKINGHOURS_CREATE_ALL = "timetracking_timetrackingemployee_timetrackingemployeeweeklyworkinghours.create.*",
  TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEEWEEKLYWORKINGHOURS_DELETE_ALL = "timetracking_timetrackingemployee_timetrackingemployeeweeklyworkinghours.delete.*",
  TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEEWEEKLYWORKINGHOURS_READ_ALL = "timetracking_timetrackingemployee_timetrackingemployeeweeklyworkinghours.read.*",
  TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEEWEEKLYWORKINGHOURS_UPDATE_ALL = "timetracking_timetrackingemployee_timetrackingemployeeweeklyworkinghours.update.*",
  TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEEYEARLYVACATIONDAYS_CREATE_ALL = "timetracking_timetrackingemployee_timetrackingemployeeyearlyvacationdays.create.*",
  TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEEYEARLYVACATIONDAYS_DELETE_ALL = "timetracking_timetrackingemployee_timetrackingemployeeyearlyvacationdays.delete.*",
  TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEEYEARLYVACATIONDAYS_READ_ALL = "timetracking_timetrackingemployee_timetrackingemployeeyearlyvacationdays.read.*",
  TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEEYEARLYVACATIONDAYS_UPDATE_ALL = "timetracking_timetrackingemployee_timetrackingemployeeyearlyvacationdays.update.*",
  TIMETRACKING_TIMETRACKINGENTRY_CREATE_ALL = "timetracking_timetrackingentry.create.*",
  TIMETRACKING_TIMETRACKINGENTRY_DELETE_ALL = "timetracking_timetrackingentry.delete.*",
  TIMETRACKING_TIMETRACKINGENTRY_READ_ALL = "timetracking_timetrackingentry.read.*",
  TIMETRACKING_TIMETRACKINGENTRY_UPDATE_ALL = "timetracking_timetrackingentry.update.*",
  TIMETRACKING_TIMETRACKINGOVERVIEW_TIMETRACKINGOVERVIEWBYMONTHVIEW_CREATE_ALL = "timetracking_timetrackingoverview_timetrackingoverviewbymonthview.create.*",
  TIMETRACKING_TIMETRACKINGOVERVIEW_TIMETRACKINGOVERVIEWBYMONTHVIEW_DELETE_ALL = "timetracking_timetrackingoverview_timetrackingoverviewbymonthview.delete.*",
  TIMETRACKING_TIMETRACKINGOVERVIEW_TIMETRACKINGOVERVIEWBYMONTHVIEW_READ_ALL = "timetracking_timetrackingoverview_timetrackingoverviewbymonthview.read.*",
  TIMETRACKING_TIMETRACKINGOVERVIEW_TIMETRACKINGOVERVIEWBYMONTHVIEW_UPDATE_ALL = "timetracking_timetrackingoverview_timetrackingoverviewbymonthview.update.*",
  TIMETRACKING_TIMETRACKINGOVERVIEW_TIMETRACKINGOVERVIEWBYYEARVIEW_CREATE_ALL = "timetracking_timetrackingoverview_timetrackingoverviewbyyearview.create.*",
  TIMETRACKING_TIMETRACKINGOVERVIEW_TIMETRACKINGOVERVIEWBYYEARVIEW_DELETE_ALL = "timetracking_timetrackingoverview_timetrackingoverviewbyyearview.delete.*",
  TIMETRACKING_TIMETRACKINGOVERVIEW_TIMETRACKINGOVERVIEWBYYEARVIEW_READ_ALL = "timetracking_timetrackingoverview_timetrackingoverviewbyyearview.read.*",
  TIMETRACKING_TIMETRACKINGOVERVIEW_TIMETRACKINGOVERVIEWBYYEARVIEW_UPDATE_ALL = "timetracking_timetrackingoverview_timetrackingoverviewbyyearview.update.*",
  TIMETRACKING_TIMETRACKINGOVERVIEW_TIMETRACKINGOVERVIEWENTRYVIEW_CREATE_ALL = "timetracking_timetrackingoverview_timetrackingoverviewentryview.create.*",
  TIMETRACKING_TIMETRACKINGOVERVIEW_TIMETRACKINGOVERVIEWENTRYVIEW_DELETE_ALL = "timetracking_timetrackingoverview_timetrackingoverviewentryview.delete.*",
  TIMETRACKING_TIMETRACKINGOVERVIEW_TIMETRACKINGOVERVIEWENTRYVIEW_READ_ALL = "timetracking_timetrackingoverview_timetrackingoverviewentryview.read.*",
  TIMETRACKING_TIMETRACKINGOVERVIEW_TIMETRACKINGOVERVIEWENTRYVIEW_UPDATE_ALL = "timetracking_timetrackingoverview_timetrackingoverviewentryview.update.*",
  USER_CREATE_ALL = "user.create.*",
  USER_DELETE_ALL = "user.delete.*",
  USER_READ_ALL = "user.read.*",
  USER_UPDATE_ALL = "user.update.*",
}
export namespace Backend {
  export namespace App.Data.Attachments {
    export type PrivateAttachmentData = {
      name: string | null;
      file: any | null;
      attachable_type: App.Enums.Administration.Attachments.PrivateAttachmentAttachableTypeEnum;
      attachable_id: string | null;
      type: App.Enums.Administration.Attachments.PrivateAttachmentTypeEnum | null;
    };
  }
  export namespace App.Data.Dashboard {
    export type PatientData = {
      state: App.Enums.PatientStateEnum;
      gender: App.Enums.PatientGenderEnum;
      first_name: string;
      last_name: string;
      birthdate: string;
      email: string;
      phone_number: string;
      requests_callback: boolean;
      request_description: string;
      diagnosis: string | null;
      diagnoses: Array<string> | null;
      previous_therapy: string | null;
      date_of_last_mri_or_ct: string | null;
      origin: App.Enums.PatientOriginEnum | null;
      other_origin: string | null;
      requests_access: boolean;
      language: App.Enums.PatientLanguageEnum;
      backoffice_user_id: string | null;
      doctor_ids: Array<string> | null;
    };
  }
  export namespace App.Data.Dashboard.Administration {
    export type AuthorData = {
      type: App.Enums.AuthorTypeEnum;
      name: string | null;
      team_member_id: string | null;
      publication_id: string | null;
    };
    export type DiagnosisData = {
      state: App.Enums.ModelStateEnum;
      title: App.Data.Meta.MultilingualAttributeData;
      parent_id: string | null;
      automatic_acceptance: boolean;
      automatic_acceptance_email_id: string | null;
      contact_form_slug?: string | null;
    };
    export type EmailData = {
      type: App.Enums.Administration.EmailTypeEnum;
      title: string;
      subject: App.Data.Meta.MultilingualAttributeData | null;
      content: App.Data.Meta.MultilingualAttributeData | null;
      pre_content: App.Data.Meta.MultilingualAttributeData | null;
      post_content: App.Data.Meta.MultilingualAttributeData | null;
      is_primary: boolean;
    };
    export type EmailPreviewData = {
      language: App.Enums.PatientLanguageEnum;
      content: App.Data.Meta.MultilingualAttributeData | null;
      pre_content: App.Data.Meta.MultilingualAttributeData | null;
      post_content: App.Data.Meta.MultilingualAttributeData | null;
      patient_id: string | null;
    };
    export type PatientEmailData = {
      cc_recipients: Array<string>;
      bcc_recipients: Array<string>;
      subject: string | null;
      pre_content: string | null;
      post_content: string | null;
      email_id: string;
    };
    export type PublicationData = {
      state: App.Enums.ModelStateEnum;
      title: string;
      journal: string;
      published_at: string;
      link_text: string;
      link_destination: string;
      abstract: string | null;
      diagnoses: Array<string> | null;
    };
    export type ReducedUserData = {
      color: string;
      roles: Array<App.Enums.Auth.RoleEnum>;
    };
    export type TeamMemberData = {
      state: App.Enums.ModelStateEnum;
      first_name: string;
      last_name: string;
      hello_one_page_slug: string | null;
    };
  }
  export namespace App.Data.Dashboard.Auth {
    export type DashboardLoginData = {
      email: string;
      password: string;
    };
    export type UserData = {
      email_signature_name: string | null;
      email_signature_email: string | null;
      default_time_tracking_entry_start_time: string | null;
      default_time_tracking_entry_end_time: string | null;
    };
  }
  export namespace App.Data.Dashboard.Inquiry {
    export type AnswerInquiryData = {
      state: App.Enums.InquiryStateEnum;
      answer: string | null;
    };
    export type InquiryData = {
      patient_id: string;
      question: string | null;
      doctor_id: string;
      cc_recipients: Array<string> | null;
      bcc_recipients: Array<string> | null;
      subject: string | null;
      pre_content: string | null;
      post_content: string | null;
      email_id: string;
    };
  }
  export namespace App.Data.Dashboard.QualityManagement {
    export type ProcessData = {
      state: App.Enums.ModelStateEnum;
      ext_id: string;
      title: string | null;
      category: App.Enums.QualityManagement.ProcessCategoryEnum | null;
      roles: Array<App.Enums.QualityManagement.ProcessRoleEnum> | null;
      description: string | null;
      goal: string | null;
      scope: string | null;
      priority: App.Enums.QualityManagement.ProcessPriorityEnum | null;
      complexity: App.Enums.QualityManagement.ProcessComplexityEnum | null;
      owner_id: string | null;
      review_cycle: number | null;
      input: string | null;
      output: string | null;
    };
    export type ProcessVersionData = {
      title: string;
      category: App.Enums.QualityManagement.ProcessCategoryEnum;
      roles: Array<App.Enums.QualityManagement.ProcessRoleEnum>;
      description: string | null;
      goal: string | null;
      scope: string | null;
      priority: App.Enums.QualityManagement.ProcessPriorityEnum | null;
      complexity: App.Enums.QualityManagement.ProcessComplexityEnum | null;
      owner_id: string | null;
      review_cycle: number | null;
      input: string | null;
      output: string | null;
      change_description: string;
    };
    export type SubProcessPivotData = {
      sub_process_id: string;
    };
  }
  export namespace App.Data.Dashboard.Statistics {
    export type StatisticsTimeframeData = {
      timeframe_start_at: string | null;
      timeframe_end_at: string | null;
    };
  }
  export namespace App.Data.Dashboard.TimeTracking {
    export type TimeTrackingAbsenceRequestCancelData = {};
    export type TimeTrackingAbsenceRequestData = {
      start_at: string;
      half_day_start: boolean;
      end_at: string;
      half_day_end: boolean;
      note_employee: string | null;
    };
    export type TimeTrackingAbsenceRequestProcessData = {
      state: App.Enums.TimeTracking.TimeTrackingAbsenceRequestStateEnum;
      note_team_leader_hr: string | null;
    };
    export type TimeTrackingEntryData = {
      start_at: string;
      end_at: string;
      type: App.Enums.TimeTracking.TimeTrackingEntryTypeEnum;
      break_time: number | null;
      comment: string | null;
    };
  }
  export namespace App.Data.Dashboard.TimeTracking.TimeTrackingEmployee {
    export type TimeTrackingEmployeeData = {
      team_leader_id: string | null;
      federal_state: App.Enums.TimeTracking.GermanStateEnum | null;
      entry_date: string | null;
    };
    export type TimeTrackingEmployeeWeeklyWorkingHoursData = {
      valid_from: string;
      hours: number;
      possible_work_days: Array<App.Enums.WeekDayEnum>;
      agreed_work_days: Array<App.Enums.WeekDayEnum>;
    };
    export type TimeTrackingEmployeeYearlyVacationDaysData = {
      valid_from: string;
      days: number;
    };
  }
  export namespace App.Data.ExtFileExchange {
    export type FileDownloadData = {
      job_id: string;
      status: string;
      info: Array<any>;
      run_id: string;
    };
  }
  export namespace App.Data.Meta {
    export type GenericMetaData = {
      private_attachments: App.Data.Meta.PrivateAttachmentMetaData;
    };
    export type MultilingualAttributeData = {
      de: string | null;
      en: string | null;
      ru: string | null;
    };
    export type PrivateAttachmentFileLimitTypeMetaData = {
      attachment_type: App.Enums.Administration.Attachments.PrivateAttachmentTypeEnum;
      max_files: number;
      new_uploads_allowed: boolean | null;
    };
    export type PrivateAttachmentMetaData = {
      file_limits: Array<App.Data.Meta.PrivateAttachmentFileLimitTypeMetaData>;
    };
    export type TitleAttributeData = {
      title: string;
    };
    export type UuidAttributeData = {
      id: string;
    };
  }
  export namespace App.Data.PatientArea {
    export type NewPatientData = {
      gender: App.Enums.PatientGenderEnum;
      first_name: string;
      last_name: string;
      birthdate: string;
      email: string;
      phone_number: string;
      requests_callback: boolean;
      request_description: string;
      diagnosis: string | null;
      previous_therapy: string | null;
      date_of_last_mri_or_ct: string | null;
      origin: App.Enums.PatientOriginEnum | null;
      other_origin: string | null;
      requests_access: boolean;
      confirmed_data_privacy: boolean;
      language: App.Enums.PatientLanguageEnum;
    };
    export type PatientData = {
      gender: App.Enums.PatientGenderEnum;
      first_name: string;
      last_name: string;
      birthdate: string;
      email: string;
      phone_number: string;
      requests_callback: boolean;
      request_description: string;
      diagnosis: string | null;
      previous_therapy: string | null;
      date_of_last_mri_or_ct: string | null;
      origin: App.Enums.PatientOriginEnum | null;
      other_origin: string | null;
      requests_access: boolean;
      confirmed_data_privacy: boolean;
      language: App.Enums.PatientLanguageEnum;
    };
  }
  export namespace App.Data.PatientArea.Auth {
    export type PatientAreaLoginData = {
      email: string;
      password: string;
    };
    export type PatientAreaSetPasswordData = {
      token: string;
      email: string;
      password: string;
    };
  }
  export namespace App.Data.Settings {
    export type TableFilterFavoriteData = {
      title: string;
      column_order: string | null;
      hidden_columns: string | null;
      per_page: number;
      sorts: string;
      filter: Array<any>;
      table_id: string;
    };
  }
  export namespace App.Enums {
    export enum AuthorTypeEnum {
      TEAM_MEMBER = "team_member",
      EXTERNAL = "external",
    }
    export enum InquiryStateEnum {
      OPEN = "open",
      WITHDRAWN = "withdrawn",
      ACCEPTED = "accepted",
      REJECTED = "rejected",
    }
    export enum ModelStateEnum {
      DRAFT = "draft",
      PUBLISHED = "published",
      LOCKED = "locked",
      ARCHIVED = "archived",
    }
    export enum PasswordResetOriginEnum {
      DASHBOARD = "dashboard",
      PATIENT_AREA = "patient_area",
    }
    export enum PatientAuthenticationAuditTypeEnum {
      PATIENT_CREATED = "patient_created",
      PASSWORD_RESET_STARTED = "password_reset_started",
      PASSWORD_RESET_SUCCESSFUL = "password_reset_successful",
      PASSWORD_RESET_ATTEMPT_FAILED = "password_reset_attempt_failed",
      LOGIN_ATTEMPT_FAILED = "login_attempt_failed",
    }
    export enum PatientEventTypeEnum {
      PATIENT_CREATED = "patient_created",
      PASSWORD_SET = "password_set",
      LOGGED_ID = "logged_in",
      FILE_UPLOADED = "file_uploaded",
      EMAIL_SENT_ACCEPTANCE = "email_sent_acceptance",
      EMAIL_SENT_ACCEPTANCE_WITHOUT_LOGIN = "email_sent_acceptance_without_login",
      EMAIL_SENT_REJECTION = "email_sent_rejection",
      EMAIL_SENT_REQUEST_RECEIVED = "email_sent_request_received",
    }
    export enum PatientGenderEnum {
      FEMALE = "female",
      MALE = "male",
      DIVERSE = "diverse",
    }
    export enum PatientLanguageEnum {
      GERMAN = "german",
      ENGLISH = "english",
      RUSSIAN = "russian",
    }
    export enum PatientOriginEnum {
      RECOMMENDATION = "recommendation",
      DOCTOR = "doctor",
      YOUTUBE = "youtube",
      PODCAST = "podcast",
      INSTAGRAM = "instagram",
      FACEBOOK = "facebook",
      TIKTOK = "tiktok",
      X = "x",
      SEARCH_ENGINE = "search_engine",
      OTHER = "other",
    }
    export enum PatientSourceEnum {
      HELLO_ONE = "hello_one",
      INTERNATIONAL_WEBSITE = "international_website",
      DIAGNOSIS_CONTACT_FORM = "diagnosis_contact_form",
    }
    export enum PatientStateEnum {
      NEW = "new",
      DOCTOR_INQUIRY_CREATED = "doctor_inquiry_created",
      EMAIL_SENT = "email_sent",
      REJECTED = "rejected",
      AUTOMATICALLY_ACCEPTED = "automatically_accepted",
    }
    export enum PatientUserAssignmentTypeEnum {
      BACKOFFICE = "backoffice",
      DOCTOR = "doctor",
    }
    export enum PublicErrorCodeEnum {
      AUTH_GENERAL_EXCEPTION = "auth_general_exception",
      SEARCH_FILTER_PROPERTY_EXCEPTION = "search_filter_property_exception",
      GENERAL_EXCEPTION = "general_exception",
      GENERAL_VALIDATION_EXCEPTION = "general_validation_exception",
      SEARCH_REQUIRED_FILTER_MISSING_EXCEPTION = "search_required_filter_missing_exception",
      ATTACHMENT_GENERAL_STORAGE_EXCEPTION = "attachment_general_storage_exception",
      LOCK_EXCEPTION = "general_lock_exception",
    }
    export enum TableConfigColumnTypeEnum {
      STRING = "string",
      BOOL = "bool",
      INT = "int",
      MONEY = "money",
      FLOAT = "float",
      ARRAY = "array",
      DATE = "date",
      TIME = "time",
      CARBON_IMMUTABLE = "carbon_immutable",
      MULTI_LANGUAGE_ATTRIBUTE_DATA = "multi_language_attribute_data",
      MODEL_STATE_ENUM = "model_state_enum",
      MODEL_STATE_STATE_MACHINE = "model_state_state_machine",
      RELATION_AUTHOR_RESOURCE = "relation_author_resource",
      FK_PUBLICATION = "fk_publication",
      RELATION_PUBLICATION_RESOURCE = "relation_publication_resource",
      FK_TEAM_MEMBER = "fk_team_member",
      RELATION_TEAM_MEMBER_RESOURCE = "relation_team_member_resource",
      PATIENT_LANGUAGE_ENUM = "patient_language_enum",
      PATIENT_STATE_ENUM = "patient_state_enum",
      PRIVATE_ATTACHMENT_TYPE_ENUM = "private_attachment_type_enum",
      PRIVATE_ATTACHMENT_ATTACHABLE_TYPE_ENUM = "private_attachment_attachable_type_enum",
      ADMINISTRATION_ATTACHMENTS_PRIVATE_ATTACHMENT_RESOURCE = "administration_attachments_private_attachment_resource",
      FK_ATTACHABLE = "fk_attachable",
      GENERIC_META_DATA = "generic_meta_data",
      EMAIL_TYPE_ENUM = "email_type_enum",
      DIAGNOSIS_RESOURCE = "diagnosis_resource",
      FK_EMAIL = "fk_email",
      EMAIL_RESOURCE = "email_resource",
      PATIENT_ORIGIN_ENUM = "patient_origin_enum",
      PATIENT_AUTHENTICATION_AUDIT_TYPE_ENUM = "patient_authentication_audit_type_enum",
      PASSWORD_RESET_ORIGIN_ENUM = "password_reset_origin_enum",
      RELATION_TITLE_ATTRIBUTE_DATA = "relation_title_attribute_data",
      FK_DIAGNOSIS = "fk_diagnosis",
      FK_DIAGNOSIS_CATEGORY = "fk_diagnosis_category",
      PATIENT_GENDER_ENUM = "patient_gender_enum",
      REDUCED_USER_RESOURCE = "reduced_user_resource",
      COMPUTED_BACKOFFICE_USER = "computed_backoffice_user",
      COMPUTED_DOCTOR = "computed_doctor",
      INL_FUNC_CUSTOM_FUNCTION = "inl_func_custom_function",
      INL_FUNC_INLINE_DELETE_BUTTON = "inl_func_inline_delete_button",
      INL_FUNC_INLINE_DOWNLOAD_BUTTON = "inl_func_inline_download_button",
      INL_FUNC_INLINE_EDIT_AND_DELETE_BUTTON = "inl_func_inline_edit_and_delete_button",
      INL_FUNC_INLINE_DOWNLOAD_AND_DELETE_BUTTON = "inl_func_inline_download_and_delete_button",
      QM_PROCESS_CATEGORY_ENUM = "qm_process_category_enum",
      QM_PROCESS_PRIORITY_ENUM = "qm_process_priority_enum",
      QM_PROCESS_COMPLEXITY_ENUM = "qm_process_complexity_enum",
      QM_PROCESS_ROLE_ENUM = "qm_process_role_enum",
      FK_USER = "fk_user",
      QM_PROCESS_RESOURCE = "qm_process_resource",
      QM_PROCESS_VERSION_RESOURCE = "qm_process_version_resource",
      FK_PROCESS = "fk_process",
      FILE_SIZE = "file_size",
      COMPUTED_TEAM_LEADER = "computed_team_leader",
      TIME_TRACKING_ENTRY_TYPE_ENUM = "time_tracking_entry_type_enum",
      TIME_TRACKING_EMPLOYEE_RESOURCE = "time_tracking_employee_resource",
      TIME_TRACKING_ABSENCE_REQUEST_STATE_ENUM = "time_tracking_absence_request_state_enum",
      FK_TIME_TRACKING_EMPLOYEE = "fk_time_tracking_employee",
      TIME_TRACKING_ABSENCE_REQUEST_ACTION_RESOURCE = "time_tracking_absence_request_action_resource",
      ROLE_RESOURCE = "role_resource",
      FK_PATIENT = "fk_patient",
      INQUIRY_STATE_ENUM = "inquiry_state_enum",
      PATIENT_RESOURCE = "patient_resource",
      PATIENT_SOURCE_ENUM = "patient_source_enum",
      GERMAN_STATE_ENUM = "german_state_enum",
      WEEK_DAY_ENUM = "week_day_enum",
      TIME_TRACKING_EMPLOYEE_WEEKLY_WORKING_HOURS_RESOURCE = "time_tracking_employee_weekly_working_hours_resource",
      TIME_TRACKING_EMPLOYEE_YEARLY_VACATION_DAYS_RESOURCE = "time_tracking_employee_yearly_vacation_days_resource",
      FK_TIME_TRACKING_ENTRY = "fk_time_tracking_entry",
    }
    export enum TableFilterDisplayTypeEnum {
      MULTI_COLUMN_FILTER = "multi_column_filter",
      SINGLE_COLUMN_DROPDOWN_FILTER = "single_column_dropdown",
    }
    export enum TableRelativeDateFilterEnum {
      TODAY = "today",
      TOMORROW = "tomorrow",
      YESTERDAY = "yesterday",
      LAST_WEEK = "last_week",
      THIS_WEEK = "this_week",
      NEXT_WEEK = "next_week",
      THIS_MONTH = "this_month",
      NEXT_MONTH = "next_month",
      THIS_YEAR = "this_year",
    }
    export enum WeekDayEnum {
      MONDAY = "monday",
      TUESDAY = "tuesday",
      WEDNESDAY = "wednesday",
      THURSDAY = "thursday",
      FRIDAY = "friday",
      SATURDAY = "saturday",
      SUNDAY = "sunday",
    }
  }
  export namespace App.Enums.Administration {
    export enum EmailPlaceholderEnum {
      PATIENT_SALUTATION = "patient_salutation",
      SALUTATION = "salutation",
      FIRST_NAME = "first_name",
      LAST_NAME = "last_name",
      NEW_LINE = "new_line",
      PATIENT_SET_PASSWORD_LINK = "patient_set_password_link",
      PATIENT_REQUEST_LINK = "patient_request_link",
      PATIENT_REQUEST_DETAILS = "patient_request_details",
      PATIENT_FILES_LINK = "patient_files_link",
      EXTERNAL_ANSWER_INQUIRY_LINK = "external_answer_inquiry_link",
      TIME_TRACKING_ABSENCE_REQUEST_LINK = "time_tracking_absence_request_link",
      EMPLOYEE_USER_NAME = "employee_user_name",
    }
    export enum EmailTypeEnum {
      PATIENT_ACCEPTANCE = "patient_acceptance",
      PATIENT_ACCEPTANCE_WITHOUT_LOGIN = "patient_acceptance_without_login",
      PATIENT_REJECTION = "patient_rejection",
      PATIENT_REQUEST_RECEIVED = "patient_request_received",
      NEW_PATIENT = "new_patient",
      NEW_PATIENT_FILE_UPLOAD = "new_patient_file_upload",
      NEW_INQUIRY = "new_inquiry",
      EXISTING_PATIENT_REQUEST = "existing_patient_request",
      TIME_TRACKING_ABSENCE_NEW_REQUEST = "time_tracking_absence_new_request",
      TIME_TRACKING_ABSENCE_REQUEST_APPROVED = "time_tracking_absence_request_approved",
      TIME_TRACKING_ABSENCE_REQUEST_REJECTED = "time_tracking_absence_request_rejected",
      TIME_TRACKING_ABSENCE_REQUEST_CANCELLED = "time_tracking_absence_request_cancelled",
    }
  }
  export namespace App.Enums.Administration.Attachments {
    export enum AttachmentMimeTypeEnum {
      IMAGE_PNG = "image/png",
      IMAGE_JPG = "image/jpeg",
      IMAGE_SVG = "image/svg+xml",
      IMAGE_WEBP = "image/webp",
      APPLICATION_PDF = "application/pdf",
    }
    export enum PrivateAttachmentAttachableTypeEnum {
      PATIENTS = "patients",
      PROCESSES = "processes",
      PROCESS_VERSIONS = "process_versions",
    }
    export enum PrivateAttachmentTypeEnum {
      PATIENT_FILE = "patient_file",
      QM_DOCUMENT = "qm_document",
    }
    export enum PrivateAttachmentUploadStateEnum {
      INCOMPLETE = "incomplete",
      COMPLETE = "complete",
    }
  }
  export namespace App.Enums.Auth {
    export enum RoleEnum {
      DEVELOPMENT = "development",
      ADMIN = "admin",
      DOCTOR = "doctor",
      USER = "user",
      QM_MANAGER = "qm_manager",
      EMPLOYEE = "employee",
      INTERNATIONAL_ADMIN = "international_admin",
      TIME_TRACKING_EMPLOYEE = "time_tracking_employee",
      TIME_TRACKING_TEAM_LEAD = "time_tracking_team_lead",
      TIME_TRACKING_HUMAN_RESOURCES = "time_tracking_human_resources",
    }
  }
  export namespace App.Enums.QualityManagement {
    export enum ProcessCategoryEnum {
      CORE = "core",
      LEADERSHIP = "leadership",
      SUPPORT = "support",
    }
    export enum ProcessComplexityEnum {
      LOW = "low",
      MEDIUM = "medium",
      HIGH = "high",
    }
    export enum ProcessPriorityEnum {
      LOW = "low",
      MEDIUM = "medium",
      HIGH = "high",
      CRITICAL = "critical",
    }
    export enum ProcessRoleEnum {
      ADMINISTRATION = "administration",
      RADIOLOGY = "radiology",
    }
  }
  export namespace App.Enums.TimeTracking {
    export enum GermanStateEnum {
      BADEN_WURTTEMBERG = "baden_wurttemberg",
      BAVARIA = "bavaria",
      BERLIN = "berlin",
      BRANDENBURG = "brandenburg",
      BREMEN = "bremen",
      HAMBURG = "hamburg",
      HESSE = "hesse",
      LOWER_SAXONY = "lower_saxony",
      MECKLENBURG_WESTERN_POMERANIA = "mecklenburg_western_pomerania",
      NORTH_RHINE_WESTPHALIA = "north_rhine_westphalia",
      RHINELAND_PALATINATE = "rhineland_palatinate",
      SAARLAND = "saarland",
      SAXONY = "saxony",
      SAXONY_ANHALT = "saxony_anhalt",
      SCHLESWIG_HOLSTEIN = "schleswig_holstein",
      THURINGIA = "thuringia",
    }
    export enum TimeTrackingAbsenceRequestStateEnum {
      OPEN = "open",
      APPROVED = "approved",
      REJECTED = "rejected",
      CANCELLED = "cancelled",
    }
    export enum TimeTrackingEntryTypeEnum {
      WORK = "work",
      SICK = "sick",
      CHILD_SICK = "child_sick",
      OFF_DAY = "off_day",
      OVERTIME_OFF = "overtime_off",
      EDUCATIONAL_LEAVE = "educational_leave",
      VACATION = "vacation",
    }
  }
  export namespace App.Resources {
    export type AbstractBaseResourceData = {};
    export type AppVersion = {
      version: string;
    };
    export type ErrorContainer = {
      error: App.Resources.Error;
    };
    export type Error = {
      message: string;
      code: App.Enums.PublicErrorCodeEnum;
    };
  }
  export namespace App.Resources.Dashboard {
    export type PatientAuthenticationAudit = {
      id: string;
      occurred_at: string;
      type: App.Enums.PatientAuthenticationAuditTypeEnum;
      email: string | null;
      password_reset_origin: App.Enums.PasswordResetOriginEnum | null;
      patient_id: string | null;
      created_at: string;
      updated_at: string;
    };
    export type Patient = {
      id: string;
      state: App.Enums.PatientStateEnum;
      gender: App.Enums.PatientGenderEnum | null;
      first_name: string;
      last_name: string;
      birthdate: string;
      email: string;
      phone_number: string;
      requests_callback: boolean;
      request_description: string;
      diagnoses?: Array<App.Resources.Dashboard.Administration.Diagnosis>;
      diagnosis_titles?: Array<App.Data.Meta.TitleAttributeData>;
      diagnosis: string | null;
      previous_therapy: string | null;
      date_of_last_mri_or_ct: string | null;
      origin: App.Enums.PatientOriginEnum | null;
      other_origin: string | null;
      requests_access: boolean;
      language: App.Enums.PatientLanguageEnum;
      files?: Array<App.Resources.Dashboard.Administration.PrivateAttachment>;
      meta: App.Data.Meta.GenericMetaData;
      backoffice_user?: App.Resources.Dashboard.Administration.ReducedUser;
      doctors?: Array<App.Resources.Dashboard.Administration.ReducedUser>;
      source: App.Enums.PatientSourceEnum;
      created_at: string;
      updated_at: string;
    };
    export type SentEmail = {
      id: string;
      sent_at: string | null;
      email_type: App.Enums.Administration.EmailTypeEnum;
      email_id: string | null;
      email?: App.Resources.Dashboard.Administration.Email;
      locale: App.Enums.PatientLanguageEnum;
      automatically_triggered: boolean;
      generated_email_content: string | null;
      created_at: string;
      updated_at: string;
    };
  }
  export namespace App.Resources.Dashboard.Administration {
    export type Author = {
      id: string;
      type: App.Enums.AuthorTypeEnum;
      name: string | null;
      publication_id: string;
      publication?: App.Resources.Dashboard.Administration.Publication;
      team_member_id: string | null;
      team_member?: App.Resources.Dashboard.Administration.TeamMember;
      created_at: string;
      updated_at: string;
    };
    export type Diagnosis = {
      id: string;
      state: App.Enums.ModelStateEnum;
      title: App.Data.Meta.MultilingualAttributeData;
      parent_id: string | null;
      is_category: boolean;
      category?: App.Resources.Dashboard.Administration.Diagnosis;
      automatic_acceptance: boolean;
      automatic_acceptance_email_id: string | null;
      automatic_acceptance_email?: App.Resources.Dashboard.Administration.Email;
      contact_form_slug: string | null;
      created_at: string;
      updated_at: string;
    };
    export type Email = {
      id: string;
      type: App.Enums.Administration.EmailTypeEnum;
      title: string;
      subject: App.Data.Meta.MultilingualAttributeData;
      content: App.Data.Meta.MultilingualAttributeData;
      pre_content: App.Data.Meta.MultilingualAttributeData;
      post_content: App.Data.Meta.MultilingualAttributeData;
      created_at: string;
      updated_at: string;
      is_primary: boolean;
    };
    export type PatientEmail = {
      id: string;
      type: App.Enums.Administration.EmailTypeEnum;
      localized_subject: string;
      localized_pre_content: string;
      localized_content: string;
      localized_post_content: string;
    };
    export type PrivateAttachment = {
      id: string;
      name: string;
      filename: string;
      image_width: number | null;
      image_height: number | null;
      mime_type: string | null;
      size: number | null;
      attachable_type: App.Enums.Administration.Attachments.PrivateAttachmentAttachableTypeEnum;
      attachable_id: string;
      type: App.Enums.Administration.Attachments.PrivateAttachmentTypeEnum;
      url: string | null;
      url_valid_until: string | null;
      created_at: string;
      updated_at: string;
    };
    export type Publication = {
      id: string;
      state: App.Enums.ModelStateEnum;
      title: string;
      journal: string;
      published_at: string;
      link_text: string;
      link_destination: string;
      abstract: string;
      authors?: Array<App.Resources.Dashboard.Administration.Author>;
      slug: string;
      diagnoses?: Array<App.Resources.Dashboard.Administration.Diagnosis>;
      diagnosis_titles?: Array<App.Data.Meta.TitleAttributeData>;
      created_at: string;
      updated_at: string;
    };
    export type ReducedUser = {
      id: string;
      name: string;
      email: string;
      color: string;
      roles?: Array<App.Resources.Dashboard.Auth.Role>;
      created_at: string;
      updated_at: string;
    };
    export type TeamMember = {
      id: string;
      state: App.Enums.ModelStateEnum;
      first_name: string;
      last_name: string;
      ext_team_member_id: string;
      hello_one_page_slug: string | null;
      created_at: string;
      updated_at: string;
    };
  }
  export namespace App.Resources.Dashboard.Auth {
    export type AuthenticatedUser = {
      id: string;
      name: string;
      email: string;
      email_verified_at: string | null;
      two_factor_auth_enabled: boolean;
      roles?: Array<App.Resources.Dashboard.Auth.Role>;
      permissions?: Array<string>;
      model_permissions?: Array<string>;
      is_backoffice_user: boolean;
      time_tracking_employee?: App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployee;
      email_signature_name: string | null;
      email_signature_email: string | null;
    };
    export type DashboardLoginResponse = {
      user: App.Resources.Dashboard.Auth.AuthenticatedUser | null;
      two_factor: boolean | null;
    };
    export type Role = {
      id: string;
      key: string;
      guard_name: string;
    };
  }
  export namespace App.Resources.Dashboard.Inquiry {
    export type Inquiry = {
      id: string;
      state: App.Enums.InquiryStateEnum;
      patient_id: string;
      patient?: App.Resources.Dashboard.Patient;
      question: string | null;
      answer: string | null;
      answered_at: string | null;
      doctor_id: string;
      doctor?: App.Resources.Dashboard.Administration.ReducedUser;
      backoffice_user_id: string;
      backoffice_user?: App.Resources.Dashboard.Administration.ReducedUser;
      created_at: string;
      updated_at: string;
    };
  }
  export namespace App.Resources.Dashboard.Meta {
    export type TableConfigColumnMeta = {
      property_for_url: string | null;
      property_for_label: string | null;
      function: string | null;
    };
    export type TableConfigColumn = {
      name: string;
      type: App.Enums.TableConfigColumnTypeEnum;
      filterable: boolean;
      quick_filter: boolean;
      required_filter: boolean;
      default_filter: Array<any> | string | null;
      sortable: boolean;
      initially_hidden: boolean;
      visible: boolean;
      filter_visible: boolean;
      show_column_header: boolean;
      meta: App.Resources.Dashboard.Meta.TableConfigColumnMeta;
    };
    export type TableConfig = {
      id: string;
      url: string;
      columns: Array<App.Resources.Dashboard.Meta.TableConfigColumn>;
      permissions: App.Resources.Dashboard.Meta.TablePermission;
      filter_type: App.Enums.TableFilterDisplayTypeEnum;
    };
    export type TablePermission = {
      create: string;
      update: string;
      delete: string;
      read: string;
    };
  }
  export namespace App.Resources.Dashboard.QualityManagement {
    export type Document = {
      id: string;
      name: string;
      size: number | null;
      process_id: string;
      process?: App.Resources.Dashboard.QualityManagement.Process;
      url: string | null;
      url_valid_until: string | null;
      created_at: string;
      updated_at: string;
    };
    export type Process = {
      id: string;
      ext_id: string;
      title: string | null;
      category: App.Enums.QualityManagement.ProcessCategoryEnum | null;
      roles: Array<App.Enums.QualityManagement.ProcessRoleEnum>;
      description: string | null;
      goal: string | null;
      scope: string | null;
      priority: App.Enums.QualityManagement.ProcessPriorityEnum | null;
      complexity: App.Enums.QualityManagement.ProcessComplexityEnum | null;
      owner_id: string | null;
      owner?: App.Resources.Dashboard.Administration.ReducedUser;
      review_cycle: number | null;
      input: string | null;
      output: string | null;
      current_version?: App.Resources.Dashboard.QualityManagement.ProcessVersion | null;
      sub_processes?: Array<App.Resources.Dashboard.QualityManagement.Process>;
      state: App.Enums.ModelStateEnum;
      documents?: Array<App.Resources.Dashboard.Administration.PrivateAttachment>;
      meta: App.Data.Meta.GenericMetaData;
      created_at: string;
      updated_at: string;
    };
    export type ProcessVersion = {
      id: string;
      version_number: number;
      change_description: string;
      ext_id: string;
      title: string;
      category: App.Enums.QualityManagement.ProcessCategoryEnum;
      roles: Array<App.Enums.QualityManagement.ProcessRoleEnum>;
      description: string | null;
      goal: string | null;
      scope: string | null;
      priority: App.Enums.QualityManagement.ProcessPriorityEnum | null;
      complexity: App.Enums.QualityManagement.ProcessComplexityEnum | null;
      owner_id: string | null;
      owner?: App.Resources.Dashboard.Administration.ReducedUser;
      review_cycle: number | null;
      input: string | null;
      output: string | null;
      process_id: string;
      process?: App.Resources.Dashboard.QualityManagement.Process;
      documents?: Array<App.Resources.Dashboard.Administration.PrivateAttachment>;
      meta: App.Data.Meta.GenericMetaData;
      created_at: string;
      updated_at: string;
    };
    export type SubProcess = {
      id: string;
      process_id: string;
      process_ext_id: string;
      process_title: string;
      process_category: App.Enums.QualityManagement.ProcessCategoryEnum;
      process_version_number: number;
      state: App.Enums.ModelStateEnum;
      created_at: string;
      updated_at: string;
    };
    export type SubProcessVersion = {
      id: string;
      process_id: string;
      process_ext_id: string;
      process_title: string;
      process_category: App.Enums.QualityManagement.ProcessCategoryEnum;
      process_version_number: number;
      state: App.Enums.ModelStateEnum;
      created_at: string;
      updated_at: string;
    };
  }
  export namespace App.Resources.Dashboard.Settings {
    export type TableFilterFavorite = {
      id: string;
      title: string;
      filter: Array<any>;
      column_order: string | null;
      hidden_columns: string | null;
      per_page: number;
      sorts: string;
      table_id: string;
    };
  }
  export namespace App.Resources.Dashboard.Statistics {
    export type Axis = {
      label: string;
      format: string;
    };
    export type Chart = {
      chart_type: string;
      chart_label: string;
      x_axis: App.Resources.Dashboard.Statistics.Axis;
      y_axis: App.Resources.Dashboard.Statistics.Axis;
      data_labels: Array<string>;
      series: Array<App.Resources.Dashboard.Statistics.Series>;
    };
    export type Series = {
      name: string;
      data: Array<string | number>;
    };
    export type Statistics = {
      charts: Array<App.Resources.Dashboard.Statistics.Chart>;
    };
  }
  export namespace App.Resources.Dashboard.TimeTracking {
    export type PublicHoliday = {
      id: string;
      name: string;
      date: string;
      federal_states: Array<App.Enums.TimeTracking.GermanStateEnum>;
      created_at: string;
      updated_at: string;
    };
    export type TimeTrackingAbsenceRequestAction = {
      process: boolean;
      cancel: boolean;
    };
    export type TimeTrackingAbsenceRequest = {
      id: string;
      time_tracking_employee_id: string;
      time_tracking_employee?: App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployee;
      start_at: string;
      end_at: string;
      days: number;
      half_day_start: boolean;
      half_day_end: boolean;
      note_employee: string | null;
      note_team_leader_hr: string | null;
      state: App.Enums.TimeTracking.TimeTrackingAbsenceRequestStateEnum;
      processed_by_id: string | null;
      processed_by?: App.Resources.Dashboard.Administration.ReducedUser;
      cancelled_by_id: string | null;
      cancelled_by?: App.Resources.Dashboard.Administration.ReducedUser;
      actions: App.Resources.Dashboard.TimeTracking.TimeTrackingAbsenceRequestAction;
      created_at: string;
      updated_at: string;
    };
    export type TimeTrackingEntry = {
      id: string;
      time_tracking_employee_id: string;
      time_tracking_employee?: App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployee;
      type: App.Enums.TimeTracking.TimeTrackingEntryTypeEnum;
      date: string;
      start_at: string;
      end_at: string;
      break_time: number | null;
      hours: number;
      overtime_hours: number | null;
      comment: string | null;
      created_at: string;
      updated_at: string;
    };
  }
  export namespace App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee {
    export type TimeTrackingEmployee = {
      id: string;
      user_id: string;
      user?: App.Resources.Dashboard.Administration.ReducedUser;
      team_leader_id: string | null;
      team_leader?: App.Resources.Dashboard.Administration.ReducedUser;
      federal_state: App.Enums.TimeTracking.GermanStateEnum | null;
      default_time_tracking_entry_start_time: string | null;
      default_time_tracking_entry_end_time: string | null;
      current_weekly_working_hours?: App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployeeWeeklyWorkingHours;
      current_yearly_vacation_days?: App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployeeYearlyVacationDays;
      entry_date: string | null;
      created_at: string;
      updated_at: string;
    };
    export type TimeTrackingEmployeeWeeklyWorkingHours = {
      id: string;
      time_tracking_employee_id: string;
      time_tracking_employee?: App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployee;
      valid_from: string;
      hours: number;
      possible_work_days: Array<App.Enums.WeekDayEnum>;
      agreed_work_days: Array<App.Enums.WeekDayEnum>;
      created_at: string;
      updated_at: string;
    };
    export type TimeTrackingEmployeeYearlyVacationDays = {
      id: string;
      time_tracking_employee_id: string;
      time_tracking_employee?: App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployee;
      valid_from: string;
      days: number;
      created_at: string;
      updated_at: string;
    };
  }
  export namespace App.Resources.Dashboard.TimeTracking.TimeTrackingOverview {
    export type TimeTrackingOverviewByMonth = {
      id: string;
      month: string | null;
      year: string | null;
      time_tracking_employee_id: string;
      time_tracking_employee?: App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployee;
      work_hours: number;
      overtime_hours: number;
      accumulated_overtime_hours: number;
      overtime_off_days: number;
      vacation_days: number;
      sick_days: number;
      child_sick_days: number;
      educational_leave_hours: number;
      off_days: number;
      created_at: string;
      updated_at: string;
    };
    export type TimeTrackingOverviewByYear = {
      id: string;
      year: string | null;
      time_tracking_employee_id: string;
      time_tracking_employee?: App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployee;
      work_hours: number;
      overtime_hours: number;
      accumulated_overtime_hours: number;
      overtime_off_days: number;
      vacation_days: number;
      sick_days: number;
      child_sick_days: number;
      educational_leave_hours: number;
      off_days: number;
      created_at: string;
      updated_at: string;
    };
    export type TimeTrackingOverviewEntry = {
      id: string;
      time_tracking_employee_id: string;
      time_tracking_employee?: App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployee;
      time_tracking_entry_id: string | null;
      date: string;
      type: App.Enums.TimeTracking.TimeTrackingEntryTypeEnum;
      start_at: string | null;
      end_at: string | null;
      break_time: number | null;
      hours: number | null;
      overtime_hours: number | null;
      comment: string | null;
      created_at: string;
      updated_at: string;
    };
  }
  export namespace App.Resources.ExtHelloOne {
    export type Diagnosis = {
      id: string;
      state: App.Enums.ModelStateEnum;
      title: App.Data.Meta.MultilingualAttributeData;
      created_at: string;
      updated_at: string;
    };
  }
  export namespace App.Resources.PatientArea.Auth {
    export type AuthenticatedPatient = {
      id: string;
      first_name: string;
      last_name: string;
      email: string;
      email_verified_at: string | null;
    };
    export type PatientAuthenticationAuditPayload = {
      password_reset_origin: App.Enums.PasswordResetOriginEnum | null;
      email: string | null;
    };
  }
}
